import styled from "styled-components";

export const Container = styled.div`
  background-color: #ffffff;
  width: 100%;
  height: 100vh;
  padding: 20px 20px 20px 20px;
  overflow-x: hidden;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

export const Title = styled.span`
  font-size: 23px;
  color: #ffffff;
`;

export const Icon = styled.span`
  font-size: 35px;
  color: #ffffff;
`;

export const CloseIcon = styled.span`
  font-size: 25px;
  color: #ffffff;
  cursor: pointer;
`;

export const Content = styled.div`
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 20px;
  border-top-left-radius: 22px;
  border-top-right-radius: 22px;
  border-bottom-left-radius: 22px;
  border-bottom-right-radius: 22px;
`;

export const CardTitle = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: #487cf5;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InfoTitle = styled.span`
  font-size: 10px;
  color: #828282;
`;

export const InfoText = styled.span`
  width: 100%;
  color: #487cf5;
  font-size: 12px;
`;

export const Hr = styled.hr``;

export const DetailsContainer = styled.div`
  width: 100%;
  height: auto;
  padding-bottom: 10px;
`;

export const DetailsContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const SectionTitle = styled.span`
  color: #487cf5;
  font-size: 12px;
  font-weight: bold;
`;

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StatusIcon = styled.div`
  background-color: ${(props) => props.color};
  width: 10px;
  height: 10px;
  border-radius: 5px;
  margin-right: 5px;
`;

export const TypeableLineContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: -4px;
`;

export const TypeableLineText = styled.span`
  width: 95%;
  color: #487cf5;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  @media (max-width: 415px) {
    width: 85%;
  }
  @media (max-width: 385px) {
    width: 75%;
  }
  @media (max-width: 355px) {
    width: 65%;
  }
`;

export const TypeableLineIcon = styled.i`
  font-size: 1rem;
  margin-left: 10px;
  color: #000000;
`;

export const ToolTipText = styled.span``;

export const ToolTipButton = styled.a`
  cursor: pointer;
`;

export const BankSlipContainer = styled.div`
  width: 100%;
  height: auto;
`;

export const BarcodeContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const BarcodeContent = styled.div`
  margin-left: -9px !important;
  display: flex;
`;

export const DownloadContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const DownloadButton = styled.div``;

export const DownloadIcon = styled.i`
  cursor: pointer;
  color: #487cf5;
  font-size: 25px;
`;

export const DownloadLoading = styled.i`
  color: #487cf5;
  font-size: 25px !important;
`;

export const ToolTipButtonPixCode = styled.div`
  cursor: pointer;
`;

export const PixQRCode = styled.div`
 height: 208px;
 width: 208px;
`;
